module.exports = __webpack_public_path__ + "static/WindingWorlds2-95565cdced55c36eb8e9545852214c98.png";